import React, { Component } from 'react'; 
import {withRouter} from 'react-router-dom';


class Footer extends Component {
    
    render() {   
        return ( 
            <footer className="footer"> 
                <img src={`${window.publicUrl}/assets/img/avatars/footer-logo.png`}  height="145" width="165"/>
            </footer>
        );
    }
}
 
export default withRouter(Footer);


// WEBPACK FOOTER //
// ./src/components/Layout/Footer.js